import { useEffect, useState } from 'react';

/** Flipped once, after the first client commit has been painted. */
let hasHydrated = false;

/**
 * Whether this component mounted as part of the initial load — the render the
 * server produced and the browser painted — rather than during a navigation
 * inside the app.
 *
 * A module flag rather than the location key: React Router restores a location
 * key from `history.state`, so a reload does not look like a fresh entry.
 * Reading the flag through `useState` makes the answer identical on the server
 * and on the client's first render (nothing has hydrated yet in either), which
 * is what keeps `motion`'s initial styles out of the hydration diff, and every
 * later mount sees a hydrated app and animates.
 *
 * The flow uses it to skip the entrance on the paint the browser performs
 * itself: nothing on that paint should be hidden waiting for JavaScript. An
 * entrance that starts at hydration is either invisible (it already finished)
 * or a jolt (it started late), it holds the LCP image back either way, and it
 * would leave a visitor without JavaScript looking at an empty card. See
 * `StepStage`.
 */
export function useIsInitialLoad(): boolean {
  const [isInitialLoad] = useState(!hasHydrated);

  useEffect(() => {
    hasHydrated = true;
  }, []);

  return isInitialLoad;
}
